<template>
  <div class="notice-page common-bg">
    <div class="notice-header">
      <div class="back" @click="handleBack">
        <van-icon name="arrow-left" color="#BEBEBE" size="16"/>
      </div>
      <div class="title">消息中心</div>
      <div class="placeholder"></div>
    </div>

    <div class="tabs-wrapper">
      <van-tabs v-model="activeTab" class="notice-tabs" background="#292A2C" title-active-color="#DFB372" title-inactive-color="#fff" style="width:80%;">
        <van-tab v-for="(item, index) in tabList" :name="index" :key="index" >
          <template #title>
            <span :class="{ 'has-badge': item.badge > 0 }">{{ item.name }}</span>
            <van-badge v-if="item.badge > 0" :content="item.badge" class="tab-badge" />
          </template>
        </van-tab>
      </van-tabs>
    </div>

    <div class="notice-content">
      <noticeKefu v-if="activeTab === 0"></noticeKefu>
      <noticeGonggao v-if="activeTab === 1" :cateid="9" @update-badge="handleBadge"></noticeGonggao>
      <noticeTongzhi v-if="activeTab === 2" :cateid="10" @update-badge="handleBadge"></noticeTongzhi>
      <noticePaomadeng v-if="activeTab === 3" :cateid="11"></noticePaomadeng>
      <noticeFankui v-if="activeTab === 4"></noticeFankui>
    </div>
  </div>
</template>

<script>
import noticeKefu from "./notice/kefu.vue"
import noticeGonggao from "./notice/gonggao.vue"
import noticeTongzhi from "./notice/tongzhi.vue"
import noticePaomadeng from "./notice/paomadeng.vue"
import noticeFankui from "./notice/fankui.vue"

export default {
  name: 'notice',
  components: {
    noticeKefu,
    noticeGonggao,
    noticeTongzhi,
    noticePaomadeng,
    noticeFankui,
  },
  data() {
    return {
      activeTab: 1,
      tabList: [
        { name: '客服', noticeType: 4, badge: 0, cateid: 0 },
        { name: '公告', noticeType: 2, badge: 0, cateid: 9 },
        { name: '通知', noticeType: 1, badge: 0, cateid: 10 },
        { name: '跑马灯', noticeType: 3, badge: 0, cateid: 0 },
        { name: '有奖反馈', noticeType: 5, badge: 0, cateid: 0 },
      ],
    };
  },
  created() {
    const noticeType = this.$route.query.noticeType;
    if (noticeType) {
      const idx = this.tabList.findIndex(t => t.noticeType == noticeType);
      if (idx !== -1) this.activeTab = idx;
    }
    this.loadUnreadBadge();
  },
  methods: {
    loadUnreadBadge() {
      this.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code === 200 && res.data) {
          const detail = res.data.unread_detail || {};
          this.tabList.forEach(t => {
            if (t.cateid === 9) t.badge = detail[9] || 0;
            if (t.cateid === 10) t.badge = detail[10] || 0;
          });
        }
      });
    },
    handleBack() {
      if (this.$route.query.from === 'home') {
        this.$router.push('/');
      } else {
        this.$router.back();
      }
    },
    handleBadge(unread) {
      if (!unread) return;
      this.tabList.forEach(t => {
        if (t.cateid === 9 && typeof unread[9] !== 'undefined') t.badge = unread[9] | 0;
        if (t.cateid === 10 && typeof unread[10] !== 'undefined') t.badge = unread[10] | 0;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.notice-page {
  min-height: 100vh;
  background: #1a1a1a;
  overflow: hidden;
}
.notice-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 200;
  padding: 0 0.3rem;
  background: #292a2c;
  .back {
    width: 0.8rem;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .title {
    flex: 1;
    text-align: center;
    color: #fff;
    font-size: 0.35rem;
    font-weight: bold;
  }
  .placeholder {
    width: 0.8rem;
  }
}
.tabs-wrapper {
  position: fixed;
  top: 44px;
  left: 0;
  right: 0;
  z-index: 190;
  background: #292A2C;
  overflow-x: auto;
  .notice-tabs {
    ::v-deep .van-tabs__nav .van-tab {
      flex: 1 1 auto;
      min-width: 1.1rem;
    }
    ::v-deep .van-tabs__nav .van-tab:nth-child(1) {
      min-width: 0.9rem;
    }
    ::v-deep .van-tabs__nav .van-tab:nth-child(2),
    ::v-deep .van-tabs__nav .van-tab:nth-child(3) {
      flex: 1.15 1 auto;
      min-width: 1.25rem;
    }
    ::v-deep .van-tabs__nav .van-tab:nth-child(4) {
      flex: 1.1 1 auto;
      min-width: 1.3rem;
    }
    ::v-deep .van-tabs__nav .van-tab:nth-child(5) {
      flex: 1.25 1 auto;
      min-width: 1.55rem;
    }
    ::v-deep .van-tabs__nav .van-tab .van-tab__text,
    ::v-deep .van-tabs__nav .van-tab .van-ellipsis {
      overflow: visible !important;
      text-overflow: unset !important;
      white-space: nowrap;
    }

    ::v-deep .van-tabs__active-bar {
      background: #DFB372 !important;
      height: 3px;
    }
    ::v-deep .van-tabs__line {
      background-color: #DFB372 !important;
    }

    
    .has-badge {
      position: relative;
    }
    .tab-badge {
      margin-left: 0.05rem;
      ::v-deep .van-badge {
        border: 1px solid #ee0a24 !important;
      }
    }
  }
}
.notice-content {
  margin-top: 98px;
  min-height: calc(100vh - 98px);
}
</style>

<style lang="scss">
.notice-page .tabs-wrapper .notice-tabs.van-tabs .van-tabs__nav .van-tab {
  flex: 1 1 auto !important;
  min-width: 1.1rem !important;
}
.notice-page .tabs-wrapper .notice-tabs.van-tabs .van-tabs__nav .van-tab:nth-child(1) {
  min-width: 0.9rem !important;
}
.notice-page .tabs-wrapper .notice-tabs.van-tabs .van-tabs__nav .van-tab:nth-child(2),
.notice-page .tabs-wrapper .notice-tabs.van-tabs .van-tabs__nav .van-tab:nth-child(3) {
  flex: 1.15 1 auto !important;
  min-width: 1.25rem !important;
}
.notice-page .tabs-wrapper .notice-tabs.van-tabs .van-tabs__nav .van-tab:nth-child(4) {
  flex: 1.1 1 auto !important;
  min-width: 1.3rem !important;
}
.notice-page .tabs-wrapper .notice-tabs.van-tabs .van-tabs__nav .van-tab:nth-child(5) {
  flex: 1.25 1 auto !important;
  min-width: 1.55rem !important;
}
.notice-page .tabs-wrapper .notice-tabs.van-tabs .van-tabs__nav .van-tab .van-tab__text,
.notice-page .tabs-wrapper .notice-tabs.van-tabs .van-tabs__nav .van-tab .van-ellipsis {
  overflow: visible !important;
  text-overflow: unset !important;
  white-space: nowrap !important;
}
.notice-page .tabs-wrapper .notice-tabs .tab-badge.van-badge {
  border: 1px solid #ee0a24 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/notice.vue